{
  "commonHeader": {
    "upgradeToPro": "Atualizar",
    "learnMore": "Saiba mais",
    "AIProductivitySuite": {
      "title": "Suite de produtividade de IA",
      "desc": "Transforme discussões inspiradoras em entregáveis impressionantes."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Gerir a conta da organização com IA",
        "description": "Obtenha respostas inteligentes às suas perguntas sobre a conta e ajuda para navegar nas definições.",
        "terms": "Ao utilizar as funcionalidades beta da Zoom, aceita {0}",
        "termsText": "os Termos do Programa Beta da Zoom"
      },
      "diveDeeper": "Explorar mais",
      "shareFeedback": "Partilhe feedback em {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Pergunte sobre a conta da sua organização",
      "heroInvite": "Como convido um novo utilizador para a minha conta?",
      "heroGroups": "Como atribuo utilizadores a grupos?",
      "heroRoles": "Como gerir funções e permissões?"
    },
    "backMainAccount": "Voltar à conta principal",
    "discoverProducts": "Descobrir produtos",
    "pricing": "Preços",
    "more": "Mais",
    "sidebarExpanded": "expandido",
    "sidebarCollapsed": "fechado",
    "search": "Pesquisar",
    "users": "Utilizadores",
    "settings": "Definições da conta",
    "navigation": "Navegação",
    "clear": "Limpar",
    "searchPlaceholderAll": "Pesquisar utilizadores, definições da conta ou navegação",
    "searchPlaceholderUsers": "Pesquisar utilizadores ou navegação",
    "searchPlaceholderSettings": "Pesquisar definições da conta ou navegação",
    "searchPlaceholderNav": "Pesquisar navegação",
    "searchGuide": "Introduza palavras-chave para iniciar a pesquisa",
    "installOnDesktop": "Instalar no ambiente de trabalho",
    "downloadCenter": "Centro de transferências",
    "getInTouch": "Contacte-nos",
    "featuredProduct": "produto em destaque",
    "logo": {
      "adminCenter": "Centro de administração",
      "subAccount": "A gerir a subconta",
      "externalAccount": "A gerir a conta delegada"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "Saiba mais",
      "gotIt": "Compreendi"
    },
    "coachMark": {
      "dvsTipsTitle": "As divisões estão agora disponíveis",
      "dvsTipsContent": "As divisões são utilizadas para criar várias instâncias de determinados produtos Zoom na sua conta."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "Saiba mais",
      "gotIt": "Compreendi"
    },
    "coachMark": {
      "extAccountTipsTitle": "Gerir contas externas",
      "extAccountTipsContent": "Precisa de gerir outra conta? Basta enviar um pedido — depois de aprovado, já pode começar!"
    }
  },
  "feedback": {
    "dialogTitle": "Enviar feedback",
    "itemLableForProductArea": "Área do produto",
    "itemLableForSatisfied": "Qual o seu grau de satisfação com a experiência?",
    "dissatisfied": "Muito insatisfeito(a)",
    "satisfied": "Muito satisfeito(a)",
    "itemLableForFeedback": "Feedback",
    "placeholder": "Agradecemos as suas ideias, comentários e sugestões.",
    "btnCancel": "Cancelar",
    "btnSubmit": "Enviar",
    "supportTips": "Para obter apoio técnico, visite",
    "btnSupport": "Apoio.",
    "messages": {
      "success": "Obrigado pelo seu feedback!",
      "productFailed": "A área do produto é obrigatória.",
      "scoreFailed": "A pontuação de satisfação é obrigatória."
    },
    "products": {
      "General": "Geral",
      "AI": "IA",
      "Apps": "Aplicações",
      "Calendar": "Calendário",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Mail",
      "Meetings": "Reuniões",
      "Notes": "Notas",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Agendador",
      "Tasks": "Tarefas",
      "TeamChat": "Chat de equipa",
      "WebinarsAndEvents": "Seminários web e eventos",
      "Whiteboard": "Quadro branco",
      "WorkflowAutomations": "Automatizações de fluxo de trabalho",
      "WorkspaceReservation": "Reserva de espaços de trabalho",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "Esta isenção de responsabilidade foi gerada pelo administrador da sua conta.",
    "cancel": "Cancelar",
    "agree": "Aceitar"
  },
  "shared": {
    "sideMenu": {
      "personal": "Pessoal",
      "admin": "Administrador",
      "menu": "Menu",
      "pinned": "Afixado",
      "pin": "Afixar",
      "unpin": "Desafixar",
      "moveItem": "Mover item",
      "myAccount": "A minha conta",
      "upgradeToPro": "Atualizar para Pro",
      "grabbedKeyboard": "{0} agarrado. Utilize as setas para cima e para baixo para mover, espaço ou Enter para largar.",
      "dropped": "{0} largado.",
      "releasedUnchanged": "{0} libertado, posição inalterada.",
      "movedToPosition": "{0} movido para a posição {1} de {2}.",
      "movedUp": "{0} movido para cima, posição {1} de {2}.",
      "movedDown": "{0} movido para baixo, posição {1} de {2}.",
      "movedUpNew": "{0} movido para cima, nova posição {1} de {2}",
      "movedDownNew": "{0} movido para baixo, nova posição {1} de {2}",
      "cannotMoveFurther": "{0} não pode ser movido mais.",
      "grabbedMouse": "{0} agarrado. Mova o rato para reposicionar, clique para largar, prima Escape para cancelar."
    },
    "item": "Item",
    "gotIt": "Compreendi",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Número de telefone adicionado com êxito. Já o pode utilizar para futuros inícios de sessão e para recuperação da conta.",
    "mfa_to_signin_phone_success": "{phone} é agora o número de início de sessão de {email}.",
    "login_passkey_bound_success": "Chave de acesso criada com êxito"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "As seguintes funcionalidades avançadas de gestão serão aplicadas apenas a utilizadores licenciados e de colaboração",
      "licensed_basic": "As seguintes funcionalidades avançadas de gestão serão aplicadas apenas a utilizadores licenciados e básicos",
      "licensed": "As seguintes funcionalidades avançadas de gestão serão aplicadas apenas a utilizadores licenciados"
    },
    "support": "- Suportado nas definições da conta e nas definições do grupo de utilizadores",
    "archive_product": {
      "title": "Arquivar reuniões e webinars",
      "detail": "- As reuniões serão arquivadas quando os utilizadores da sua conta aderirem. Para utilizar esta definição, instale uma <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">aplicação de arquivo</a> no Zoom App Marketplace."
    },
    "restrict": {
      "title": "Restringir a utilização de funcionalidades selecionadas quando os utilizadores aderem a uma reunião",
      "detail": "- As funcionalidades selecionadas não podem ser utilizadas mesmo que os anfitriões as ativem para as reuniões."
    },
    "meeting_integration": {
      "title": "Ativar a integração DLP (prevenção de perda de dados) do chat na reunião",
      "detail": "- Quando ativada, a DLP aplica-se às mensagens de chat públicas e privadas enviadas por um participante. As mensagens serão imediatamente eliminadas se os participantes de uma reunião (interna/externa) estiverem a conversar e uma mensagem violar as políticas de conformidade da organização anfitriã."
    },
    "chat_tool": {
      "title": "Ferramenta de etiqueta de chat",
      "detail": "- Identificar palavras-chave e padrões de texto definidos no conteúdo partilhado e impedir que os utilizadores partilhem mensagens indesejadas"
    },
    "information_barriers": {
      "title": "Barreiras de informação",
      "detail": "- As barreiras de informação controlam as comunicações entre determinados utilizadores para fins de conformidade. Podem ser impostas restrições a reuniões e chat entre utilizadores de dois grupos, e determinados utilizadores podem ser impedidos de utilizar funcionalidades específicas (por exemplo, chat na reunião, partilha de ecrã e transferência de ficheiros). Estas restrições impedem a troca de informações confidenciais entre utilizadores não autorizados."
    },
    "dashboard": {
      "title": "Painel",
      "detail": "- No painel reuniões > reuniões anteriores, os dados são apresentados apenas durante 3 meses para alguns utilizadores"
    },
    "reports": {
      "title": "Relatórios",
      "detail": "- Alguns relatórios de utilizador apresentam dados de apenas 3 meses para alguns utilizadores: relatório de isenção de responsabilidade, relatório de registo de participantes, relatório de registos de atividade do administrador e relatório de início/terminação de sessão"
    },
    "close": "Fechar"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "O seu {planName} será cancelado em {cancelDate}. Antes dessa data, pode reativar as suas licenças de webinars. De {supportStartDate} a {supportEndDate}, contacte o apoio ao cliente para obter os dados dos webinars existentes. Depois de {dataLossDate}, perderá todos os dados de webinars.",
            "nonAdmin": "O seu {planName} será cancelado em {cancelDate}. Até essa data, pode contactar o administrador da conta para reativar as suas licenças de webinars. De {supportStartDate} a {supportEndDate}, contacte o apoio ao cliente para obter os dados dos webinars existentes. Depois de {dataLossDate}, perderá todos os dados dos webinars da sua conta."
          },
          "admin": "O seu {planName} será cancelado em {cancelDate}. Até essa data, pode reativar as suas licenças de webinars. De {supportStartDate} a {supportEndDate}, contacte o apoio ao cliente para obter {supportContent} dos webinars existentes. Depois de {dataLossDate}, perderá todos os dados dos webinars da sua conta.",
          "nonAdmin": "O seu {planName} será cancelado em {cancelDate}. Até essa data, pode contactar o administrador da conta para reativar as suas licenças de webinars. De {supportStartDate} a {supportEndDate}, contacte o apoio ao cliente para obter {supportContent} dos webinars existentes. Depois de {dataLossDate}, perderá todos os dados dos webinars da sua conta."
        },
        "expired": {
          "admin": "O seu {planName} foi cancelado. De {supportStartDate} a {supportEndDate}, pode contactar o apoio ao cliente para obter {supportContent} dos webinars existentes ou voltar a comprar o Zoom Webinars para restaurar o acesso aos dados. Depois de {dataLossDate}, perderá todos os dados dos webinars da sua conta.",
          "nonAdmin": "O seu {planName} foi cancelado. De {supportStartDate} a {supportEndDate}, pode contactar o apoio ao cliente para aceder a {supportContent} dos webinars existentes, ou o administrador da conta para voltar a comprar o Zoom Webinars e restaurar o acesso aos dados. Depois de {dataLossDate}, perderá todos os dados dos webinars da sua conta."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "O seu {planName} será colocado em pausa em {pausedDate} durante {pauseDuration}. Durante esse período, só pode ver os webinars existentes e os respetivos conteúdos. Pode remover a pausa e retomar a subscrição das suas licenças de webinars em qualquer momento.",
            "nonAdmin": "O seu {planName} será colocado em pausa em {pausedDate} durante {pauseDuration}. Durante esse período, só pode ver os webinars existentes e os respetivos conteúdos. Contacte o administrador da sua conta para remover a pausa e retomar a subscrição das suas licenças de webinars em qualquer momento."
          },
          "admin": "O seu {planName} será colocado em pausa em {pausedDate} durante {pauseDuration}. Durante esse período, só pode ver {supportContent}. Pode remover a pausa e retomar a subscrição das suas licenças de webinars em qualquer momento.",
          "nonAdmin": "O seu {planName} será colocado em pausa em {pausedDate} durante {pauseDuration}. Durante esse período, só pode ver {supportContent}. Contacte o administrador da sua conta para remover a pausa e retomar a subscrição das suas licenças de webinars em qualquer momento."
        },
        "active": {
          "webinars": {
            "admin": "O seu {planName} está em pausa durante {pauseDuration} a partir de {pausedDate}. Durante a pausa, só pode ver os webinars existentes. Pode retomar a subscrição das suas licenças de webinars em qualquer momento.",
            "nonAdmin": "O seu {planName} está em pausa durante {pauseDuration} a partir de {pausedDate}. Durante a pausa, só pode ver os webinars existentes. Pode contactar o administrador da sua conta para retomar a subscrição das suas licenças de webinars em qualquer momento."
          },
          "admin": "O seu {planName} está em pausa durante {pauseDuration}. Durante a pausa, só pode ver {supportContent} dos webinars existentes. Pode retomar a subscrição das suas licenças de webinars em qualquer momento.",
          "nonAdmin": "O seu {planName} está em pausa durante {pauseDuration}. Durante a pausa, só pode ver {supportContent} dos webinars existentes. Pode contactar o administrador da sua conta para retomar a subscrição das suas licenças de webinars em qualquer momento."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "Sua licença {planName} será pausada em {pausedDate} por {pauseDuration}. Para continuar organizando webinars, aloque uma licença ativa para este usuário antes que a pausa entre em vigor. Você também pode remover a pausa para continuar usando esta licença.",
            "nonAdmin": "Sua licença {planName} será pausada em {pausedDate} por {pauseDuration}. Durante esse período, você poderá exibir apenas os webinars existentes e seus ativos. Para continuar organizando webinars, entre em contato com o administrador da conta para alocar uma licença ativa à sua conta antes que a pausa entre em vigor."
          },
          "active": {
            "admin": "Sua licença de {planName} está em pausa por {pauseDuration} a partir de {pausedDate}. Durante a pausa, você pode exibir apenas os webinars existentes. Fique à vontade para retomar a assinatura da licença ou alocar uma licença ativa à sua conta para continuar a organizar webinars.",
            "nonAdmin": "Sua licença {planName} está em pausa por {pauseDuration} a partir de {pausedDate}. Durante a pausa, você pode exibir apenas os webinars existentes. Para organizar webinars durante a pausa, entre em contato com o administrador da sua conta para alocar uma licença ativa à sua conta."
          }
        },
        "cancel": {
          "active": {
            "admin": "A sua licença {planName} será cancelada em {cancelDate}. Para continuar a organizar webinars, reative a sua licença de webinars ou atribua uma licença ativa antes de o cancelamento entrar em vigor. Se não for tomada qualquer ação, terá um período de carência de {supportStartDate} a {supportEndDate} para contactar o apoio ao cliente e obter os dados dos webinars existentes. Depois de {dataLossDate}, todos os dados de webinars associados à sua conta serão eliminados de forma permanente.",
            "nonAdmin": "A sua licença {planName} será cancelada em {cancelDate}. Para continuar a organizar webinars, contacte o administrador da conta para reativar a sua licença de webinars ou atribuir uma licença ativa antes de o cancelamento entrar em vigor. Se não for tomada qualquer ação, terá um período de carência de {supportStartDate} a {supportEndDate} para contactar o apoio ao cliente e obter os dados dos webinars existentes. Depois de {dataLossDate}, todos os dados de webinars associados à sua conta serão eliminados de forma permanente."
          },
          "expired": {
            "admin": "Sua licença do {planName} foi cancelada. Para continuar realizando webinars, aloque uma licença ativa a este usuário. De {supportStartDate} a {supportEndDate}, você pode entrar em contato com o Suporte ao cliente para recuperar os dados de webinars existentes.",
            "nonAdmin": "Sua licença do {planName} foi cancelada. Para continuar realizando webinars, entre em contato com o administrador da conta para alocar uma licença ativa ao seu perfil. De {supportStartDate} a {supportEndDate}, entre em contato com o Suporte ao cliente para recuperar os dados de webinars existentes."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "Sua licença {planName} será pausada em {pausedDate} por {pauseDuration}. Durante o período de pausa, você pode exibir apenas {supportContent} dos webinars anteriores. Para continuar acessando os ativos dos webinars, aloque uma licença ativa a este usuário antes que a pausa entre em vigor. Você também pode remover a pausa para continuar usando esta licença.",
              "nonAdmin": "Sua licença {planName} será pausada em {pausedDate} por {pauseDuration}. Durante o período de pausa, você poderá exibir apenas {supportContent}. Para continuar a acessar os ativos dos webinars, entre em contato com o administrador da conta para alocar uma licença ativa ao seu perfil."
            },
            "active": {
              "admin": "Seu {planName} está em pausa por {pauseDuration} a partir de {pausedDate}. Durante a pausa, você pode exibir apenas {supportContent} dos webinars existentes. Para continuar a acessar os ativos dos webinars, aloque uma licença ativa à sua conta. Você também pode retomar a assinatura desta licença a qualquer momento.",
              "nonAdmin": "Seu {planName} está em pausa por {pauseDuration} a partir de {pausedDate}. Durante a pausa, você pode exibir apenas {supportContent} dos webinars existentes. Para organizar webinars durante a pausa, entre em contato com o administrador da conta para alocar uma licença ativa à sua conta."
            }
          },
          "cancel": {
            "active": {
              "admin": "Seu {planName} será cancelado em {cancelDate}. Para continuar realizando webinars, aloque uma licença ativa à sua conta antes que o cancelamento entre em vigor. Você pode reativar esta licença antes de {cancelDate}. De {supportStartDate} a {supportEndDate}, você pode entrar em contato com o Suporte ao cliente para recuperar {supportContent} dos webinars existentes.",
              "nonAdmin": "A sua licença {planName} será cancelada em {cancelDate}. Para continuar a organizar webinars, contacte o administrador da conta para reativar a sua licença de webinars ou atribuir uma licença ativa antes de o cancelamento entrar em vigor. Se não for tomada qualquer ação, terá um período de carência de {supportStartDate} a {supportEndDate} para contactar o apoio ao cliente e obter {supportContent} dos webinars existentes. Depois de {dataLossDate}, todos os dados de webinars associados à sua conta serão eliminados de forma permanente."
            },
            "expired": {
              "admin": "Sua licença do {planName} foi cancelada. Para continuar realizando webinars, aloque uma licença ativa a este usuário. De {supportStartDate} a {supportEndDate}, entre em contato com o Suporte ao cliente para recuperar {supportContent} dos webinars existentes.",
              "nonAdmin": "Sua licença do {planName} foi cancelada. Para continuar realizando webinars, entre em contato com o administrador da conta para alocar uma licença ativa ao seu perfil. De {supportStartDate} a {supportEndDate}, entre em contato com o Suporte ao cliente para recuperar {supportContent} dos webinars existentes."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "dados",
        "recordingsAndTranscripts": "gravações e transcrições",
        "reports": "relatórios",
        "summaries": "resumos",
        "dashboard": "painéis"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "gravações e transcrições de webinars anteriores",
          "reports": "relatórios de webinars anteriores",
          "summaries": "resumos de webinars anteriores",
          "dashboard": "painéis de webinars anteriores",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Reativar plano",
    "purchasePlan": "Comprar plano",
    "removePause": "Remover pausa",
    "resumeSubscription": "Retomar subscrição",
    "month": "mês",
    "months": "meses",
    "assignLicense": "Alocar licença"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "Compreendi"
    },
    "coachMark": {
      "tipsTitle": "O livro de endereços passará a ser o diretório de clientes",
      "tipsContent": "Na versão de outubro de 2026, vamos alterar o nome de Livro de endereços para Diretório de clientes, para refletir melhor a sua finalidade. Todas as funcionalidades, permissões e fluxos de trabalho existentes permanecerão iguais — continuará a gerir listas de clientes (livros de endereços) e contactos tal como faz hoje."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "Estamos a atualizar os nossos termos e políticas",
    "agreeSub": "Ao continuar a utilizar o Zoom, aceita os <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Termos de Serviço</a> e a <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Política de Privacidade</a> atualizados.",
    "continue": "Continuar"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Voltar à conta principal",
      "backLinkedAccount": "Voltar à conta associada",
      "backMyAccount": "Voltar à Minha conta",
      "myAccount": "A minha conta"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "O Custom AI Companion está agora disponível para a sua conta",
      "desc": "Eis algumas das funcionalidades do Custom AI Companion que pode utilizar na sua conta:",
      "studioTitle": "AI Studio",
      "studioDesc": "Personalize a experiência do AI Companion para a sua organização.",
      "integrationsTitle": "Integrações de terceiros",
      "integrationsDesc": "Tire partido de aplicações de terceiros para simplificar os seus fluxos de trabalho.",
      "clipsTitle": "Avatares personalizados para o Zoom Clips",
      "clipsDesc": "Permita que os utilizadores personalizem avatares de IA para utilizar nos seus clips."
    },
    "coachMark": {
      "licenseTitle": "Tem {0} licenças do Custom AI Companion para atribuir",
      "licenseDesc": "Atribua estas licenças em <b>Gestão de utilizadores</b> para que os seus utilizadores possam começar a usar as funcionalidades avançadas do AI Companion.",
      "settingTitle": "Consulte as definições do Custom AI Companion da sua conta",
      "settingDesc": "Configure as definições de cada funcionalidade Custom AI em <b>Definições da conta</b>. <a href=\"/account/setting?tab=aicompanion\">Ir para as definições</a>",
      "groupSettingTitle": "Consulte as definições Custom AI do seu grupo",
      "groupSettingDesc": "Configure as definições de cada funcionalidade Custom AI em <b>Definições do grupo</b>. <a href=\"/account/group\">Ir para as definições</a>"
    },
    "common": {
      "learnMore": "Saiba mais",
      "quickTour": "Fazer uma visita rápida",
      "remindLater": "Lembrar-me mais tarde",
      "dismiss": "Fechar",
      "next": "Seguinte",
      "back": "Voltar",
      "gotIt": "Compreendi",
      "goToSetting": "Ir para as definições"
    },
    "aiPanelToast": "Ative a definição <b>Painel de IA no Zoom Workplace</b> para começar a utilizar todas as funcionalidades do Custom AI Companion."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Compreendi",
      "next": "Seguinte",
      "remindMeLater": "Lembrar-me mais tarde",
      "waffleMenuTitle": "Bem-vindo à nova experiência Web do Zoom",
      "waffleMenuDesc": "Aceda aos produtos Zoom de qualquer lugar com o nosso novo <b>menu de produtos.</b>",
      "profileMenuTitle": "A minha conta",
      "profileMenuDesc": "Encontre o seu perfil e as definições pessoais em <b>A minha conta.</b>",
      "personalTitle": "Aceda a tudo o que precisa",
      "personalDesc": "<b>A minha conta</b> inclui o seu perfil, definições, transcrições de reuniões e muito mais.",
      "adminCenterTitle": "Encontre as definições da organização no Centro de administração",
      "adminCenterDesc": "O seu novo <b>Centro de administração</b> permite-lhe configurar produtos e ajustar definições para toda a organização.",
      "adminMenuForTitle": "Utilize o Centro de administração como um profissional",
      "adminMenuForAccountSettings": "<b>Definições</b> permite-lhe aceder às definições de produto predefinidas para todos na sua organização.",
      "adminMenuForContentManagementItem": "Em <b>Gestão de conteúdo</b> pode gerir todo o conteúdo gerado pelos utilizadores.",
      "adminMenuForConfigureProductsItem": "<b>Configuração de produtos</b> permite-lhe configurar os seus produtos e concluir tarefas de administrador.",
      "adminMenuForNoItems": "O novo centro de administração permite-lhe aceder e gerir mais facilmente as definições da conta e os produtos. Também pode afixar os itens que pretender para um acesso mais rápido.",
      "tryNewExperience": "Experimentar a nova experiência",
      "tryNewExperienceDetail": "Experimente! Pode sempre regressar a esta experiência clássica.",
      "tryNewExperienceTitle": "Novo visual para o Zoom Web!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Todos os direitos reservados.",
    "terms": "Termos",
    "privacy": "Privacidade",
    "trust_center": "Centro de confiança",
    "acceptable_use_guidelines": "Diretrizes de utilização aceitável",
    "legal": "Jurídico",
    "do_not_sell_my_personal_information": "As suas escolhas de privacidade",
    "cookie_preferences": "Preferências de cookies",
    "pricing": "Planos e preços",
    "feedback": "Feedback",
    "contact_us": "Contacte-nos"
  },
  "termChange": {
    "changeTerm": {
      "title": "Acordo de alteração do prazo de renovação",
      "quoteNumbers": "Formulário(s) de encomenda modificado(s) - {0}",
      "content1": "Ao aceitar estes termos, o Cliente concorda em modificar o prazo de renovação da subscrição existente de todos os formulários de encomenda entre a Zoom Communications, Inc. (“Zoom”) e o Cliente, alterando o prazo comprometido de uma renovação mensal para um {0}. Em contrapartida deste compromisso, a Zoom concorda em manter os preços atuais do Cliente durante o primeiro novo prazo de renovação.",
      "content2": "O Cliente compreende que o novo prazo de renovação de {0} se aplica assim que o Cliente clicar em “Aceito” abaixo, e que o novo prazo de renovação terá início no dia seguinte ao termo do prazo de renovação mensal atual do Cliente. Este novo prazo de renovação aplicar-se-á a todos os formulários de encomenda atualmente em vigor com a Zoom, e todos os prazos de renovação futuros ao abrigo destes formulários de encomenda terão a mesma duração.",
      "content3": "O Cliente reconhece que a única alteração é a do prazo de renovação e que todos os restantes termos e condições de cada formulário de encomenda atualmente em vigor com a Zoom permanecem inalterados e em pleno vigor de acordo com os respetivos termos.",
      "content4": "O utilizador concorda ainda que se trata de um compromisso contratual entre o Cliente e a Zoom.",
      "agreementText": "Ao clicar em “Aceito”, certifica que está autorizado a efetuar esta alteração em nome do Cliente e que o Cliente concorda com os termos e condições detalhados acima.",
      "IDecline": "Recuso",
      "IAccept": "Aceito"
    },
    "unableToChangeTerm": {
      "title": "Não é possível alterar o prazo de renovação",
      "content": "A sua conta não é elegível para atualizar o prazo de renovação. <a target=\"_blank\" href=\"{0}\">Contacte-nos</a> se se tratar de um erro.",
      "acceptedTitle": "Prazo de renovação prorrogado",
      "acceptedContent": "Já aceitou anteriormente os termos de renovação. Não é necessária qualquer outra ação.",
      "GotIt": "Compreendi"
    },
    "termLengthUpdated": "A duração do prazo de renovação foi atualizada para {0} meses.",
    "termLengthUnchanged": "A duração do prazo permanece inalterada.",
    "errorInfo": "Ocorreu um erro do servidor. Tente novamente.",
    "x12MonthTerm": "prazo de doze (12) meses",
    "x24MonthTerm": "prazo de vinte e quatro (24) meses",
    "x12MonthTermPlural": "doze (12) meses",
    "x24MonthTermPlural": "vinte e quatro (24) meses"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "A sua conta está agendada para atualizar para a <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">nova experiência web do Zoom</a> em {0}.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Rever quando atualizar</a>"
    },
    "completed": {
      "content": "A nova experiência web do Zoom está agora ativa para todos os utilizadores da sua conta. Os utilizadores verão a interface atualizada no próximo início de sessão."
    }
  }
}
